import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { UserService } from '../../core/api/user.service';
import { AppNavComponent } from '../../shared/app-nav.component';
import { BackButtonComponent } from '../../shared/back-button.component';
import { TranslatePipe } from '../../shared/translate.pipe';

@Component({
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink, AppNavComponent, BackButtonComponent, TranslatePipe],
  template: `
        <app-nav></app-nav>
    <main class="page-shell">
      <header class="topbar">
        <app-back></app-back>
        <h1>{{ 'password.title' | t }}</h1>
      </header>
      <form class="form-card" [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-grid">
          <label>{{ 'password.current' | t }}
            <input type="password" formControlName="currentPassword" autocomplete="current-password" />
          </label>
          <label>{{ 'password.new' | t }}
            <input type="password" formControlName="newPassword" autocomplete="new-password" />
          </label>
          <label>{{ 'password.confirm' | t }}
            <input type="password" formControlName="confirmPassword" autocomplete="new-password" />
          </label>
        </div>
        @if (success()) { <p class="success notice">{{ success() | t }}</p> }
        @if (error()) { <p class="error notice">{{ error() | t }}</p> }
        <div class="form-actions">
          <a class="button secondary" routerLink="/dashboard">{{ 'common.cancel' | t }}</a>
          <button class="button" type="submit" [disabled]="form.invalid || saving()">{{ (saving() ? 'common.saving' : 'common.save') | t }}</button>
        </div>
      </form>
    </main>
  `
})
export class ChangePasswordPage {
  readonly saving = signal(false);
  readonly error = signal('');
  readonly success = signal('');
  private readonly fb = inject(FormBuilder);

  readonly form = this.fb.nonNullable.group({
    currentPassword: ['', Validators.required],
    newPassword: ['', Validators.required],
    confirmPassword: ['', Validators.required]
  });

  constructor(private readonly api: UserService) {}

  submit(): void {
    if (this.form.invalid) return;
    this.saving.set(true);
    this.error.set('');
    this.success.set('');
    const raw = this.form.getRawValue();
    this.api.changePassword({
      CurrentPassword: raw.currentPassword,
      NewPassword: raw.newPassword,
      ConfirmPassword: raw.confirmPassword
    }).subscribe({
      next: () => { this.saving.set(false); this.success.set('password.changed'); this.form.reset(); },
      error: err => { this.error.set(err?.error?.Message ?? err?.error?.message ?? 'password.error'); this.saving.set(false); }
    });
  }
}
